import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        44 Siddhi Industrial park, Waghodia,<br/> Gujarat, India
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        <a href="tel:9825025940">  (+91)9825025940</a>
      
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        <a href="mailto:info@mercuryhc.com">info@mercuryhc.com</a>
 
      </li>
    </ul>
  );
}
